export default __webpack_public_path__ + "static/media/background.bbf0a90f.svg";